import { API_BASE_URL } from "@/config";
import { validate_id } from "@/utils/validations";
import { useToast } from '@/components/Toast/useToast';

export default {
    name: 'IndividualBankAccountForm',
    setup() {
        const { showSuccess, showError } = useToast();
        
        return {
            showSuccess,
            showError
        };
    },
    data() {
        return {
            form: {
              initials: '',
              surname: '',
              id_number: '',
              branch_code: '',
              account_type: '',
              account_number: '',
              id_type: '',
              bank_name: ''
            },
            banks: [],
            account_types: [],
            id_types: [],
            error: '',
            json_data: {},
            error_messages: {
                initials: '',
                surname: '',
                id_number: '',
                branch_code: '',
                account_type: '',
                account_number: '',
                id_type: '',
                bank_name: ''
            }
        };
    },
    emits: ['service_status_complete'],
    watch: {
        'form.id_number': function(val) {
            if (val && val.length == 13) {
                var id_test = validate_id(val);
                if (id_test) {
                    this.form.id_type = "SID";
                }
                else {
                    if (this.form.id_type == "SID") {
                        this.form.id_type = "";
                    }
                }
            }
            else {
                if (this.form.id_type == "SID") {
                    this.form.id_type = "";
                }
            }
        }
    },
    methods: {
        get_banks() {
            const TOKEN = localStorage.getItem('token');
            const GET_BANKS_URL = `${API_BASE_URL}/verify_api/customer_management_api/get_banks/`;

            $.ajax({
                url: GET_BANKS_URL,
                method: 'GET',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                success: (response) => {
                    this.banks = response.map(bank => ({ id: bank.id, name: bank.bank_name }));
                },
                error: () => {
                    console.error('Failed to fetch banks');
                }
            });
        },

        get_account_types() {
            const TOKEN = localStorage.getItem('token');
            const GET_ACCOUNT_TYPES_URL = `${API_BASE_URL}/verify_api/customer_management_api/get_account_types/`;

            $.ajax({
                url: GET_ACCOUNT_TYPES_URL,
                method: 'GET',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                success: (response) => {
                    this.account_types = response.map(acc => ({ id: acc.id, name: acc.account_type }));
                },
                error: () => {
                    console.error('Failed to fetch account types');
                }
            });
        },

        get_id_types() {
            const TOKEN = localStorage.getItem('token');
            const GET_ID_TYPES_URL = `${API_BASE_URL}/verify_api/customer_management_api/get_id_types/`;

            $.ajax({
                url: GET_ID_TYPES_URL,
                method: 'GET',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                success: (response) => {
                    this.id_types = response;
                },
                error: () => {
                    console.error('Failed to fetch ID types');
                }
            });
        },

        validate_fields() {
            this.error_messages = {};

            if (!this.form.initials) {
                this.error_messages.initials = 'Initials are required';
            }
            if (!this.form.surname) {
                this.error_messages.surname = 'Surname is required';
            }
            if (!this.form.id_number) {
                this.error_messages.id_number = 'ID number is required';
            } else if (this.form.id_number.length === 13 && !validate_id(this.form.id_number)) {
                this.error_messages.id_number = 'Invalid South African ID number';
            }
            if (!this.form.id_type) {
                this.error_messages.id_type = 'ID type is required';
            }
            if (!this.form.bank_name) {
                this.error_messages.bank_name = 'Bank name is required';
            }
            if (!this.form.account_type) {
                this.error_messages.account_type = 'Account type is required';
            }
            if (!this.form.account_number) {
                this.error_messages.account_number = 'Account number is required';
            }
            if (!this.form.branch_code) {
                this.error_messages.branch_code = 'Branch code is required';
            }

            return Object.keys(this.error_messages).length === 0;
        },

        handle_submit() {
            if (!this.validate_fields()) {
                return;
            }

            const initials_pattern = /^[A-Za-z]+$/;
            if (!initials_pattern.test(this.form.initials)) {
                this.error_messages.initials = 'Initials format is invalid';
                return;
            }

            const surname_pattern = /^[A-Za-z]+$/;
            if (!surname_pattern.test(this.form.surname)) {
                this.error_messages.surname = 'Surname format is invalid';
                return;
            }

            const id_number_pattern = /^[0-9]+$/;
            if (!id_number_pattern.test(this.form.id_number)) {
                this.error_messages.id_number = 'ID number format is invalid';
                return;
            }

            const TOKEN = localStorage.getItem('token');
            const INDIVIDUAL_BANK_ACCOUNT_API = `${API_BASE_URL}/verify_api/instant_verify_api/individual_bank_account_verify/`;

            this.error = '';

            $.ajax({
                url: INDIVIDUAL_BANK_ACCOUNT_API,
                method: 'POST',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                data: JSON.stringify({
                    initials: this.form.initials,
                    surname: this.form.surname,
                    id_number: this.form.id_number,
                    branch_code: this.form.branch_code,
                    account_type: this.form.account_type,
                    account_number: this.form.account_number,
                    id_type: this.form.id_type,
                    bank_name: this.form.bank_name
                }),
                beforeSend: () => {
                    Swal.fire({
                        text: 'Loading ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading(),
                    });
                },
                success: () => {
                    Swal.close();
                    this.showSuccess('Successful', 'Individual bank account verification ran successfully', 3000);
                    this.$emit('service_status_complete');
                    this.form.initials = '';
                    this.form.surname = '';
                    this.form.id_number = '';
                    this.form.branch_code = '';
                    this.form.account_type = '';
                    this.form.account_number = '';
                    this.form.id_type = '';
                    this.form.bank_name = '';
                },
                error: (error) => {
                    Swal.close();
                    let error_message = 'Something went wrong!';

                    if (error.responseJSON && error.responseJSON.message) {
                        error_message = error.responseJSON.message;
                    }

                    this.showError('Error', error_message);
                }
            });
        }
    },
    mounted() {
        this.get_banks();
        this.get_account_types();
        this.get_id_types();
    }
};
